export default __webpack_public_path__ + "pcdj-dex.51f63dbe.png";